import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Redirect } from "react-router";
import moment from "moment";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import "../../static/style/dashboard.css";
import "rc-slider/assets/index.css";
import Button from "../../components/Button";
import { moveDue, analyticsDue } from "../../actions/index";

class MoveDueDate extends Component {
  constructor(props, context) {
    super(props, context);

    this.confirmDueChange = this.confirmDueChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.changeDue = this.changeDue.bind(this);

    this.state = {
      redirect: false,
      modal: false,
      due: 7,
      anime: ""
    };
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  changeDue(days) {
    this.setState({
      due: days,
      anime: "anim"
    });

    setTimeout(() => {
      this.setState({ anime: "" });
    }, 500);
  }

  componentDidMount() {
    let redirect = false;

    if (!this.props.debts) {
      redirect = true;
    }

    if (!redirect) {
      const iid = this.props.match.params.id;
      let debt = null;

      for (const inst of this.props.debts) {
        if (Number(inst.id) === Number(iid)) {
          debt = inst;
          break;
        }
      }

      if (!debt) {
        for (const inst of this.props.invoices) {
          if (Number(inst.id) === Number(iid)) {
            debt = inst;
            break;
          }
        }
      }

      if (debt) {
        this.setState({
          debt
        });
      } else {
        this.setState({
          redirect: true
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    //console.log("update");
    if (this.props.MoveDue !== prevProps.MoveDue) {
      if (this.props.MoveDue.reload === true) {
        //console.log("here we go!");
        this.props.history.push("/dashboard");
        return true;
      }
    }
  }

  confirmDueChange() {
    this.props.analyticsDue(this.state.debt.avoinna, this.state.due);
    this.props.moveDue(this.state.debt.id, this.state.due);
  }

  render() {
    if (this.state.redirect === true) {
      return <Redirect to="/" />;
    }
    const debt = this.state.debt;

    if (debt) {
      let due = moment(debt.erapaiva);
      let newDue = moment(debt.erapaiva).add(this.state.due, "days");

      return (
        <div className="row">
          <div className={"col-sm-12"}>
            <h1 className="header1">
              <FormattedMessage
                id="app.duedate.move"
                defaultMessage="Siirrä eräpäivää"
              />
            </h1>
            <div className={"card"}>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="card-title">{debt.paamies.nimi}</h3>
                    <h6 className="card-subtitle mb-2 ass-card-guide-s">
                      <FormattedMessage
                        id="app.dashcard.case_no"
                        defaultMessage="Asianumero"
                      />: {debt.nro}
                    </h6>
                    <hr />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.dashcard.sum"
                        defaultMessage="Avoin summa"
                      />
                    </p>
                    <p className="ass-card-price">{debt.avoinna}</p>
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.dashcard.due_date"
                        defaultMessage="Eräpäivä"
                      />
                    </p>
                    <p className="ass-card-price">{due.format("D.M.YYYY")}</p>
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.dashcard.new_due_date"
                        defaultMessage="Uusi eräpäivä"
                      />
                    </p>
                    <p className="ass-card-text">
                      <input
                        type={"radio"}
                        name={"due-radio"}
                        defaultChecked
                        onClick={() => this.changeDue(7)}
                      />
                      <FormattedMessage
                        id="app.dashcard.due_one_week"
                        defaultMessage=" Siirrän eräpäivää viikolla"
                      />
                      <br />
                      <input
                        type={"radio"}
                        name={"due-radio"}
                        onClick={() => this.changeDue(15)}
                      />
                      <FormattedMessage
                        id="app.dashcard.due_two_weeks"
                        defaultMessage=" Siirrän eräpäivää kahdella viikolla"
                      />
                    </p>
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.duedate.new_due"
                        defaultMessage="Uusi eräpäivä"
                      />
                    </p>
                    <p className={this.state.anime + " ass-card-price"}>
                      {newDue.format("D.M.YYYY")}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p className="ass-card-text">
                      <FormattedMessage
                        id="app.duedate.more1"
                        defaultMessage="
                  Voit halutessasi siirtää laskun eräpäivää yhdellä tai kahdella viikolla eteenpäin. Kahdella viikolla siirtäminen maksaa 5,00 euroa, joka sinun tulee lisätä laskun loppusummaan. Siirretystä eräpäivästä ei lähetetä uutta laskua."
                      />
                    </p>
                    <p className={"ass-card-text"}>
                      <FormattedMessage
                        id="app.duedate.more2"
                        defaultMessage="Huomioithan, että voit tehdä eräpäivän siirron vain kerran ja siirto tulee tehdä viimeistään laskun eräpäivänä."
                      />
                    </p>
                  </div>
                </div>
                <div className={"row"}>
                  <div className={"col-12"}>
                    <hr />
                    <Button
                      btnText={
                        <FormattedMessage
                          id="button.lbl.move_due"
                          defaultMessage="SIIRRÄ"
                        />
                      }
                      btnStyle="primary"
                      btnPath="/dashboard"
                      btnState={this.state.btnState}
                      onClick={this.confirmDueChange}
                    />
                    <Button
                      btnText={
                        <FormattedMessage
                          id="button.lbl.cancel"
                          defaultMessage="PERUUTA"
                        />
                      }
                      btnStyle="secondary"
                      btnPath={"/dashboard"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
            >
              <ModalHeader toggle={this.toggle}>
                Eräpäivän siirtäminen
              </ModalHeader>
              <ModalBody>
                <p className={"ass-card-text"}>
                  <FormattedMessage
                    id="app.duedate.more3"
                    defaultMessage="
                 Luotsissa voit siirtää eräpäivää yhdellä tai kahdella viikolla eteenpäin. Kahdella viikolla siirtäminen maksaa 5,0 euroa, joka sinun tulee lisätä laskun
                  loppusummaan. Siirretystä eräpäivästä ei lähetetä uutta
                  laskua."
                  />
                </p>
                <p className={"ass-card-text"}>
                  <FormattedMessage
                    id="app.duedate.more4"
                    defaultMessage="
                  Huomioithan, että eräpäivän siirto tulee tehdä viimeistään
                  laskun eräpäivänä."
                  />
                </p>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={this.toggle}
                  btnText={
                    <FormattedMessage
                      id="button.lbl.close"
                      defaultMessage="SULJE"
                    />
                  }
                />
              </ModalFooter>
            </Modal>
          </div>
        </div>
      );
    }
    return "ha";
  }
}

const mapStateToProps = function(store) {
  return {
    debts: store.debts.debts,
    invoices: store.invoices.invoices,
    MoveDue: store.MoveDue
  };
};

const mapDispatchToProps = dispatch => ({
  moveDue: (id, days) => dispatch(moveDue(id, days)),
  analyticsDue: (sum, days) => dispatch(analyticsDue(sum, days))
});

export default connect(mapStateToProps, mapDispatchToProps)(MoveDueDate);



// WEBPACK FOOTER //
// ./src/containers/Duedate/MoveDueDate.js